import { useQuery } from '@tanstack/react-query'

import { importDipsLocalizations } from '~/store/dips-entity.api'

import { MultiQueryOptions } from '../useMultiQuery'

/**
 * Fetch DIPS localizations and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useLocalizationQuery = (options?: MultiQueryOptions) => {
    const localizationQuery = useQuery({
        queryFn: () => importDipsLocalizations(),
        queryKey: ['dipsLocalizations'],
        enabled: !options?.skip,
        staleTime: options?.staleTime,
        refetchInterval: options?.refetchInterval,
        refetchOnWindowFocus: options?.refetchOnWindowFocus,
    })

    return localizationQuery
}
